import combineReducers from "../../utils/combine-reducer"
import { ActionTypes } from "../actions/act_types"

const isLoading = (state = 0, action: any) => {
  switch (action.type) {
    case ActionTypes.REDIRECT:
    case ActionTypes.USER_LOG_OUT:
    case ActionTypes.START_LOADING:
      return ++state

    // Never below zero: an extra "stop" made the counter negative, and -1 is truthy (permanent loader) (FE-TECH-R12).
    case ActionTypes.STOP_LOADING:
      return Math.max(0, state - 1)

    default:
      return state
  }
}

const productsAreLoading = (state = 0, action: any) => {
  switch (action.type) {
    case ActionTypes.START_FETCHING_PRODUCTS:
      return ++state

    case ActionTypes.FETCH_PRODUCTS_SUCCESS:
    case ActionTypes.FETCH_PRODUCTS_FAIL:
      return Math.max(0, state - 1)

    default:
      return state
  }
}

const message = (state = null, action: any) => {
  switch (action.type) {
    case ActionTypes.REDIRECT:
    case ActionTypes.USER_LOG_OUT:
      return null

    case ActionTypes.START_LOADING:
      return action.message || null

    case ActionTypes.STOP_LOADING:
      return null

    default:
      return state
  }
}

const reducers = {
  isLoading,
  productsAreLoading,
  message,
}

const loading = combineReducers<typeof reducers>(reducers)

export default loading